import { Stack } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ADMIN_CONTRACTS_SEARCH_URL, ADMIN_CONTRACTS_URL } from '../../constants/routeUrls';
import { useConfig } from '../../hooks/useConfig';
import ContractSearch from '../Contracts/ContractSearch';
import JumpTo from '../shared/JumpTo';

// Universal search for the top-right of the header (SubNav). Contract name,
// line item id, and ad group id search — available from every admin page.
// Each control routes to the relevant record/list, so none of them depends on
// the contract list page's context. Contract search routes to the list as
// /admin/contracts?search=<name>; the list reads that param and applies it as a
// name filter (works whether the list is already open or reached from another tab).
function HeaderSearch() {
  const { apiHostFor } = useConfig();
  const navigate = useNavigate();

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <ContractSearch
        host={apiHostFor('contractSearch')}
        path={ADMIN_CONTRACTS_SEARCH_URL}
        placeholder="Contract"
        onSelect={(name) => navigate(`${ADMIN_CONTRACTS_URL}?search=${encodeURIComponent(name)}`)}
      />
      <JumpTo jumpType="lineItem" />
      <JumpTo jumpType="adGroup" />
    </Stack>
  );
}

export default HeaderSearch;
